import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-2 col-sm-2 col-xl-2" }
const _hoisted_2 = { class: "card h-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times",
  style: {"fontsize":"1rem","color":"#f1416c"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_6 = { class: "symbol symbol-60px mb-6" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "fs-5 fw-bolder mb-2" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "symbol symbol-60px mb-6" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fs-5 fw-bolder mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: {"text-align":"end","margin-right":"10px","/* position":"fixed","*/\n          margin-left":"119px","position":"absolute","right":"0","top":"9px","display":"block","height":"125px","width":"125px","text-indent":"0","text-decoration":"none","cursor":"pointer"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.removes($event)))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        ($setup.props.fileType != 'pdf')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "text-gray-800 text-hover-primary d-flex flex-column",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openBasic && $setup.openBasic(...args)))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: `https://api.titcrm.com${$setup.props.fileUrl}`,
                  alt: "",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.openBasic && $setup.openBasic(...args))),
                  style: {"cursor":"pointer"}
                }, null, 8, _hoisted_7),
                _createVNode(_component_Dialog, {
                  header: "Görsel",
                  visible: $setup.displayBasic,
                  "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.displayBasic) = $event)),
                  style: { width: '100vw' }
                }, {
                  footer: _withCtx(() => []),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("img", {
                        src: `https://api.titcrm.com${$setup.props.fileUrl}`,
                        style: {"display":"block","margin-left":"auto","margin-right":"auto","width":"50%"}
                      }, null, 8, _hoisted_8)
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString($setup.props.fileTitle), 1)
            ]))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: `http://89.252.140.40:1000/${$setup.props.fileUrl}`,
              target: "_blank",
              class: "text-gray-800 text-hover-primary d-flex flex-column"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: `media/svg/files/${$setup.props.fileType}.svg`,
                  alt: "",
                  style: {"cursor":"pointer"}
                }, null, 8, _hoisted_12),
                _createElementVNode("div", _hoisted_13, _toDisplayString($setup.props.fileTitle), 1)
              ])
            ], 8, _hoisted_10))
      ])
    ])
  ]))
}